import { render, staticRenderFns } from "./GoodsDetailsLables.vue?vue&type=template&id=1a48c888"
import script from "./GoodsDetailsLables.vue?vue&type=script&lang=js"
export * from "./GoodsDetailsLables.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetailsLables.vue?vue&type=style&index=0&id=1a48c888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports